import React from "react";
import ButtonMC from "../../../presentation/components/ButtonMC";

const AddOptionButton = ({
  chatbotOption,
  optionsList,
  addNewOption
}) => {
  const renderAddOptionButton = () => {
    if (chatbotOption.interactive == 'buttons' && optionsList.length >= 3) return;
    if (chatbotOption.interactive == 'list' && optionsList.length >= 10) return;

    return (
      <div className="col-md-12 mt-20 px-0 text-center">
        <ButtonMC
          text="Agregar opción"
          icon="plus-outline"
          iconPosition="left"
          variant="SECONDARY"
          outlined
          size="small"
          className="tw-mx-auto tw-w-fit"
          onClick={addNewOption}
        />
      </div>
    );
  };

  return (
    <>
      {renderAddOptionButton()}
    </>
  );
};

export default AddOptionButton;
